<div class="custom-border-features default-feature-view" *ngIf="schema">
  <div class="row feature-container filters-section-title"
       [attr.id]="featureName + 'Header'">
    <div class="col-2 fillIn-space"
         (click)="onToggleCollapse()"
         (keydown.enter)="onToggleCollapse()"
         (keydown.space)="onToggleCollapse(); $event.preventDefault()"></div>
    <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 filters-heading"
         (click)="onToggleCollapse()"
         (keydown.enter)="onToggleCollapse()"
         (keydown.space)="onToggleCollapse(); $event.preventDefault()">
      <span class="feature-selected"
            [attr.id]="featureName + '-heading-text'">{{ featureName }}</span>
      <img [hidden]="!description"
           class="info"
           src="/assets/img/info.png"
           alt="Information"
           placement="right"
           [autoClose]="'outside'"
           [ngbTooltip]="descriptionTooltip"
           triggers="click:blur"
           tooltipClass="my-aoc-class default-feature-tooltip"
           #descTip="ngbTooltip"
           (click)="descTip.open(); $event.stopPropagation()"
           (keydown.enter)="descTip.open(); $event.stopPropagation()"
           (keydown.space)="descTip.open(); $event.stopPropagation(); $event.preventDefault()" />
      <ng-template #descriptionTooltip>
        <div class="row app-area-container">
          <div class="col-9 title-tooltip">{{ featureName }}</div>
          <div class="col-3 tooltip-image">
            <button type="button"
                    class="tooltip-close"
                    aria-label="Close feature information"
                    (click)="descTip.close(); $event.stopPropagation()">
              <img src="/assets/img/close.png" alt="" />
            </button>
          </div>
          <br />
          <p class="tooltip-description">{{ description }}</p>
        </div>
      </ng-template>
    </div>

    <div class="signifyBookmd"
         [ngClass]="{ myReset: isDefault, myResetBtn: !isDefault }">
      <span *ngIf="isDefault"
            [attr.id]="featureName + '-default-button'">Default</span>
      <span *ngIf="!isDefault"
            [attr.id]="featureName + '-restore-default-button'"
            (click)="onRestoreDefault(); $event.stopPropagation()"
            (keydown.enter)="onRestoreDefault(); $event.stopPropagation()"
            (keydown.space)="onRestoreDefault(); $event.stopPropagation(); $event.preventDefault()">Restore default</span>
    </div>

    <div class="col-3 col-xl-3 col-lg-3 col-md-3 col-sm-3"
         (click)="onToggleCollapse()"
         (keydown.enter)="onToggleCollapse()"
         (keydown.space)="onToggleCollapse(); $event.preventDefault()"></div>

    <div class="col-1 col-md-1 col-lg-1 col-xl-1 text-checkbox"
         (click)="$event.stopPropagation()"
         (keydown.enter)="$event.stopPropagation()"
         (keydown.space)="$event.stopPropagation()">
        <input type="checkbox"
               class="secondary-checkbox"
               [attr.id]="featureName + 'IncludeCheck'"
               [attr.name]="featureName + 'IncludeCheck'"
               [checked]="featureSelected"
               [disabled]="disableCheckbox"
               (change)="onIncludeChange($any($event.target).checked)"
               [attr.aria-label]="featureName + ' Include in configuration'" />
            <label [attr.for]="featureName + 'IncludeCheck'">
        <span [attr.id]="featureName + '-config-checkbox'"
              class="extra-border-includeconfig"></span>
      </label>
    </div>

    <div [attr.id]="featureName + '-expandArrow-button'"
         class="col-1 filters-heading"
         [ngClass]="collapsed
                      ? 'row feature-container filters-section-title button-collapse'
                      : 'row feature-container filters-section-title button-collapse collapsed'"
         (click)="onToggleCollapse()"
         (keydown.enter)="onToggleCollapse()"
         (keydown.space)="onToggleCollapse(); $event.preventDefault()"></div>
  </div>

  <div class="row feature-container"
       [attr.id]="featureName + '-body'">
    <div class="col-2 sub-feature-selected custom-align"></div>
    <div class="col-10 filter-list"
         [ngClass]="collapsed ? 'showDiv' : 'hidediv'">
      <ng-container *ngFor="let prop of renderableProperties; trackBy: trackByKey">
        <div class="row lmu-container paramter-custom default-feature-row"
             *ngIf="prop.kind === 'checkbox'">
          <div class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text checkbox-label"
               [attr.id]="prop.key">
            <label [attr.for]="prop.key + 'Value'">{{ prop.label }}</label>
            <input type="checkbox"
                   class="secondary-checkbox"
                   [attr.id]="prop.key + 'Value'"
                   [attr.name]="prop.key"
                   [checked]="!!model?.[prop.key]"
                   [disabled]="prop.readOnly"
                   (change)="onValueChange(prop, $any($event.target).checked)"
                   [attr.aria-label]="prop.label" />
            <label [attr.for]="prop.key + 'Value'">
              <span class="extra-border-includeconfig"></span>
            </label>
          </div>
        </div>

        <div class="row lmu-container paramter-custom default-feature-row"
             *ngIf="prop.kind === 'number' || prop.kind === 'text'">
          <div class="col-3 col-md-4 col-lg-4 col-xl-4 secondColumnCss custom-button middle-text"
               [attr.id]="prop.key">{{ prop.label }} :</div>
          <div class="col-6 custom-button">
            <input class="form-control lum-text"
                   [ngClass]="{ 'showingError': !!errorState[prop.key] }"
                   [attr.id]="prop.key + 'Value'"
                   [attr.name]="prop.key"
                   [type]="prop.kind === 'number' ? 'number' : 'text'"
                   [disabled]="prop.readOnly"
                   [attr.min]="prop.min"
                   [attr.max]="prop.max"
                   [attr.minlength]="prop.minLength"
                   [attr.maxlength]="prop.maxLength"
                   [attr.placeholder]="prop.default !== undefined ? prop.default : null"
                   [ngModel]="model?.[prop.key]"
                   (ngModelChange)="onValueChange(prop, $event)" />
            <span *ngIf="prop.unit" class="unit-lumin">{{ prop.unit }}</span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
